import { useCallback } from 'react';
import { useUI, usePreviewContext } from '../contexts';

type UseRenderCallbacksParams = {
  handleNewEntry: (type: 'file' | 'folder') => void;
  startEditorResize: (clientY: number) => void;
};

export function useRenderCallbacks({
  handleNewEntry,
  startEditorResize,
}: UseRenderCallbacksParams) {
  // Get UI state from context
  const { showCreateMenu, setShowCreateMenu } = useUI();

  // Get preview state from context
  const { setPreviewVersion, setSandboxedPreview } = usePreviewContext();
  const toggleShowCreateMenu = useCallback(() => {
    setShowCreateMenu(!showCreateMenu);
  }, [showCreateMenu, setShowCreateMenu]);

  const handleNewFile = useCallback(() => {
    handleNewEntry('file');
  }, [handleNewEntry]);

  const handleNewFolder = useCallback(() => {
    handleNewEntry('folder');
  }, [handleNewEntry]);

  const handleStartEditorResize = useCallback(
    (clientY: number) => {
      startEditorResize(clientY);
    },
    [startEditorResize]
  );

  const handleRestartPreview = useCallback(() => {
    setPreviewVersion((v) => v + 1);
  }, [setPreviewVersion]);

  const handleToggleSandbox = useCallback(() => {
    setSandboxedPreview((v) => !v);
  }, [setSandboxedPreview]);

  return {
    toggleShowCreateMenu,
    handleNewFile,
    handleNewFolder,
    handleStartEditorResize,
    handleRestartPreview,
    handleToggleSandbox,
  };
}
